import { UrlQueryService } from "services/UrlQueryService/UrlQueryService";

export const getAllowedFilterParams = (urlQueryService: UrlQueryService, allowedKeys: string[] = []) => {
  const searchParams = urlQueryService.getOnlyThisSearchParams();
  return Array.from(searchParams)
    .filter(([key]) => allowedKeys.length === 0 || allowedKeys.includes(key))
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");
};
